import {useEditor} from 'TemplateEditor/EditorProvider'
import {useTemplate} from 'TemplateEditor/TemplateProvider'
import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import styled from 'styled-components'

/**
 * Organization template editor: pick which ticket tier drives
 * `visible_ticket_ids` while previewing (no attendee billing context).
 */
export function PreviewTicketBar() {
  const {t} = useI18n()
  const {
    editMode,
    nonInteractiveSalesInViewerMode,
    viewerEventTicketId,
    setViewerEventTicketId,
  } = useEditor()
  const {event} = useTemplate()

  if (editMode || !nonInteractiveSalesInViewerMode) {
    return null
  }

  const tickets = event?.tickets ?? []
  if (tickets.length === 0) {
    return null
  }

  const selectValue =
    viewerEventTicketId === undefined || viewerEventTicketId === null
      ? ''
      : String(viewerEventTicketId)

  return (
    <Bar>
      <Label htmlFor="template-preview-ticket-tier">
        {t('templateEditor.previewAsTicketLabel')}
      </Label>
      <Select
        id="template-preview-ticket-tier"
        value={selectValue}
        onChange={(e) => {
          const v = e.target.value
          if (v === '') {
            setViewerEventTicketId(undefined)
          } else {
            const n = parseInt(v, 10)
            setViewerEventTicketId(Number.isFinite(n) ? n : undefined)
          }
        }}
      >
        <option value="">{t('templateEditor.previewAsTicketAll')}</option>
        {tickets.map((tier) => (
          <option key={tier.id} value={String(tier.id)}>
            {tier.name}
          </option>
        ))}
      </Select>
      <Hint>{t('templateEditor.previewAsTicketHint')}</Hint>
    </Bar>
  )
}

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 16px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--clr-border-1, #e0e0e0);
  background: var(--clr-bg-muted, #f6f7f9);
  font-size: 0.875rem;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 6;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
`

const Label = styled.label`
  font-weight: 600;
  color: var(--clr-text, #333);
  margin: 0;
`

const Select = styled.select`
  min-width: 0;
  max-width: 100%;
  flex: 1 1 160px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid var(--clr-border-1, #ccc);
  background: #fff;
  font-size: 0.875rem;
`

const Hint = styled.span`
  color: #666;
  flex: 1 1 200px;
  min-width: 0;
  line-height: 1.35;
`
